
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14.2 14.2","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.528 10V4.208h1.72c1.77 0 2.656.616 2.656 1.848 0 .65-.23 1.125-.688 1.424-.453.299-1.125.448-2.016.448h-.4V10H5.528zM6.8 6.896h.464c.512 0 .867-.059 1.064-.176.203-.123.304-.323.304-.6 0-.31-.11-.52-.328-.632-.213-.112-.57-.168-1.072-.168H6.8v1.576z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M7.071 0A7.07 7.07 0 000 7.071 7.07 7.07 0 107.071 0zm4.125 11.197a5.81 5.81 0 01-4.125 1.708 5.81 5.81 0 01-4.125-1.708 5.81 5.81 0 01-1.709-4.125 5.81 5.81 0 011.709-4.125 5.81 5.81 0 014.125-1.709 5.81 5.81 0 014.125 1.709 5.81 5.81 0 011.709 4.125 5.81 5.81 0 01-1.709 4.125z","fill":"currentColor"}})])
          )
        }
      }
    